import { Fragment } from 'react';

import useOmeLoading from './UseOmeLoading';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

const OmeLoading = () => {
  const {
    isLoading
  } = useOmeLoading();

  return (
    <Fragment>
      <PopUpModal
        widthPct={30}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default OmeLoading;